import "reflect-metadata";
import { container } from "tsyringe";
import { EventBus } from "./commons/eventBus/eventBus";
import { DependencyInjectionProductsInfrastructure } from "./products/dependencyInjectorProductsInfrastructure";
import { DependencyInjectionUtilsInfrastructure } from "./utils/dependencyInjectorUtilsInfrastructure";
import { DependencyInjectionLocationsInfrastructure } from "./locations/dependencyInjectorLocationsInfrastructure";
import DependencyInjectionRentersInfrastructure from "./renters/dependencyInjectorRentersInfrastructure";
import DependencyInjectionVideosInfrastructure from "./videos/dependencyInjectorVideosInfrastructure";
import DependencyInjectorCustomersInfrastructure from "./customers/dependencyInjectorCustomersInfrastructure";
import DependencyInjectioOrdersInfrastructure from "./orders/DependencyInjectioOrdersInfrastructure";
import DependencyInjectionBannersInfrastructure from "./banners/dependencyInjectorBannersInfrastructure";
import DependencyInjectioIpsInfrastructure from "./ips/DependencyInjectioIpsInfrastructure";
import DependencyInjectorConfigsInfrastructure from "./configurations/dependencyInjectorConfigsInfrastructure";
import { useStoreAplication } from "./persistence/zuntand/useStoreAplication";
/**
 * Slimmed-down DI initializer for the Search Bar bundle.
 * Excludes websocket/socket manager wiring so the search-bar.js
 * bundle can tree-shake those dependencies.
 */
const dependencyInjectionInfrastructureSearch = () => {
    container.registerInstance("IEventBus", EventBus.getInstance());
    DependencyInjectionProductsInfrastructure();
    DependencyInjectionUtilsInfrastructure();
    DependencyInjectionLocationsInfrastructure();
    DependencyInjectionRentersInfrastructure();
    DependencyInjectionVideosInfrastructure();
    DependencyInjectorCustomersInfrastructure();
    DependencyInjectioOrdersInfrastructure();
    DependencyInjectionBannersInfrastructure();
    DependencyInjectioIpsInfrastructure();
    DependencyInjectorConfigsInfrastructure();
    container.register("IUseStoreAplication", {
        useFactory: () => useStoreAplication(),
    });
};
export default dependencyInjectionInfrastructureSearch;
